import axios from 'axios';

const quotation = async (body) => {
    return await axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}WLD_Miniapp_Quote`,
        data: body,
    });
}

const recibeQuotation = async (body) => {
    return await axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}WLD_Recibe_Quote&fiat=GTQ`,
        data: body,
    });
}

const initiatePayment = async (body) => {
    return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}initiatePaymentMiniapp`,
        data: body
    });
} 

const confirmPayment = async (body) => {
    return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}confirmPaymentMiniapp`,
        data: body
    });
} 

const sendTransaction = async (body) => {
    return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}WLD_Operations`,
        data: body
    });
} 

const modifyTransaction = async (body) => {
    return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}modifyTransaction`,
        data: body
    });
} 

const getWallet = async () => {
    return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}WLD_Get_Wallet`,
    });
}
export { quotation, recibeQuotation, initiatePayment, confirmPayment, sendTransaction, getWallet, modifyTransaction };